import * as THREE from "three";

export const playgroundItems = [
  {
    modelPath: "ball.glb",
    position: new THREE.Vector3(20, 0.3, 3),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2.9,
    friction: 1,
    physicsShape: "sphere",
    interactionCallback: null,
  },

  // acrylic 1
  {
    modelPath: "acrylic_stand_2025_alt.glb",
    position: new THREE.Vector3(10.5, 0.3, 2.5),
    rotation: new THREE.Euler(
      (-0.11 * Math.PI) / 2,
      -0.15 * Math.PI,
      (-0.11 * Math.PI) / 2
    ),
    scale: new THREE.Vector3(1, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.01,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(11, 0.3, 2),
    rotation: new THREE.Euler(0, (-0.5 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(3, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(11, 1, 2),
    rotation: new THREE.Euler(0, (-0.5 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.3, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(10.9, 2, 2),
    rotation: new THREE.Euler(0, (-0.56 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1.7, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(10.9, 3, 2),
    rotation: new THREE.Euler(0, (-0.49 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1.7, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(12, 0.3, 3),
    rotation: new THREE.Euler(0, (0.49 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1.4, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  //acrylic 2
  {
    modelPath: "foundation.glb",
    position: new THREE.Vector3(16.2, 0.3, 2.7),
    rotation: new THREE.Euler(0, -0.18 * Math.PI, 0),
    scale: new THREE.Vector3(1, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.01,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(17, 0.3, 2),
    rotation: new THREE.Euler(0, (-0.5 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(3, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(17, 1, 2),
    rotation: new THREE.Euler(0, (-0.5 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2.3, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(16.9, 2, 2),
    rotation: new THREE.Euler(0, (-0.56 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1.7, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(16.9, 3, 2),
    rotation: new THREE.Euler(0, (-0.49 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1.7, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(18, 0.3, 3),
    rotation: new THREE.Euler(0, (0.49 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(1.4, 1, 1),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 30,
    friction: 0.8,
    physicsShape: "box",
    interactionCallback: null,
  },
];

export const playgroundThroughableItems = [
  {
    modelPath: "ball.glb",
    position: new THREE.Vector3(20, 0.3, 10),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(0.7, 0.7, 0.7),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 0.3,
    friction: 1,
    restitution: 1,
    physicsShape: "sphere",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(22, 0.3, 13),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },

  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25, 0.3, 10),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25.2, 1.3, 10),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25.5, 2.3, 10),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube_yellow.glb",
    position: new THREE.Vector3(25.1, 3.3, 10),
    rotation: new THREE.Euler(0.4, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    restitution: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(24.8, 4.3, 10),
    rotation: new THREE.Euler(0.8, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube_.glb",
    position: new THREE.Vector3(25.4, 0.3, 10),
    rotation: new THREE.Euler(0.6, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25.6, 1.3, 10),
    rotation: new THREE.Euler(0.112, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25.7, 2.3, 10),
    rotation: new THREE.Euler(0.32, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25.2, 3.3, 10),
    rotation: new THREE.Euler(1.57, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(0.9, 0.7, 1.3),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
  {
    modelPath: "beveled_cube.glb",
    position: new THREE.Vector3(25.1, 4.3, 10),
    rotation: new THREE.Euler(0, (2 / 2) * Math.PI, 0),
    scale: new THREE.Vector3(2, 2, 2),
    type: "box",
    enableCollision: true,
    enablePhysics: true,
    mass: 2,
    friction: 1,
    physicsShape: "box",
    interactionCallback: null,
  },
];
